export const brand = {
  name: 'methodic',
  descriptor: 'AI automation & implementation for growing businesses.',
  /* TEMPLATE CONFIG: set a real address to show a mailto link in the footer. Empty = hidden. */
  email: '',
  /* TEMPLATE CONFIG: set a full company profile URL to show the LinkedIn link. Empty = hidden. */
  linkedin: '',
};

export const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Approach', href: '#approach' },
  { label: 'Outcomes', href: '#outcomes' },
];

export const workingSteps = [
  { index: '01', title: 'Share the friction', desc: 'Tell us which workflow is slowing your team down and where the work gets stuck.' },
  { index: '02', title: 'Define the opportunity', desc: 'Identify what can be automated, which systems are involved, and where human oversight matters.' },
  { index: '03', title: 'Plan the next step', desc: 'Align on a practical implementation scope, responsibilities, and measures of success.' },
];

export const services = [
  { index: '01', title: 'Customer operations', desc: 'Triage, routing, follow-up and CRM updates.', href: '/services/customer-operations' },
  { index: '02', title: 'Finance operations', desc: 'Reconciliation, reporting and recurring data work.', href: '/services/finance-operations' },
  { index: '03', title: 'Sales operations', desc: 'Lead intake, qualification and handoffs.', href: '/services/sales-operations' },
  { index: '04', title: 'Internal workflows', desc: 'Approvals, knowledge retrieval and repetitive admin.', href: '/services/internal-workflows' },
];

export const steps = [
  { index: '01', title: 'Discover', desc: 'Find where work slows down.' },
  { index: '02', title: 'Implement', desc: 'Connect AI to the systems already in use.' },
  { index: '03', title: 'Improve', desc: 'Measure what changed and keep refining.' },
];

export const outcomes = [
  { title: 'Less manual work', desc: 'Reduce repetitive steps.' },
  { title: 'Faster operations', desc: 'Move information and decisions faster.' },
  { title: 'Fewer errors', desc: 'Reduce duplicated entry and missed handoffs.' },
  { title: 'Better visibility', desc: 'Make workflow performance easier to understand.' },
];